'use client';

import Link from "next/link";
import { useEffect, useState } from "react";
import { ArrowUpRight, Sparkles } from "lucide-react";
import GlobalTitle from "@shared/GlobalTitle";
import SectionShapes from "@shared/SectionShapes";
import {
    ReactIcon, NextjsIcon, VueIcon, AngularIcon, TypeScriptIcon, HTMLIcon, PowerBIIcon, OpenCVIcon, JavaScriptIcon, TensorFlowIcon, OracleIcon, FastAPIIcon,
    NodejsIcon, PythonIcon, PhpIcon, LaravelIcon, DotNetIcon, MagnetoIcon, PowerAutomateIcon, ViteIcon, CSSIcon, FlaskIcon, ApacheIcon, QlikIcon, ZimbraIcon,
    AWSIcon, AzureIcon, GoogleCloudIcon, AzureDevopsIcon, KotlinIcon, CodeIgniterIcon, ZohoIcon, ReduxIcon, AntDesignIcon, djangoIcon, GoLangIcon,
    DockerIcon, WooCommerceIcon, SwiftIcon, JenkinsIcon, AdobeIcon, ShopifyIcon, GitIcon, NotionIcon, MaterialIcon, MSOfficeIcon, RailsIcon,
    MySqlIcon, PostgreSqlIcon, MongoDbIcon, NginxIcon, JavaIcon, OpenCartIcon, UIPathIcon, SeleniumIcon, SassIcon, CSharpIcon, CpanelIcon,
    FlutterIcon, WordpressIcon, FigmaIcon, AtlassianIcon, DrupalIcon, FirebaseIcon, JoomlaIcon, CypressIcon, TailwindIcon, jQueryIcon,
    BootstrapIcon, SpringbootIcon, KubernetesIcon, PrometheusIcon, DigitalOceanIcon, CloudflareIcon, RedisIcon, SQLServerIcon,
    AndroidIcon, AppleIcon, DartIcon, GitHubIcon, JestIcon, SalesforceIcon, SAPIcon, OdooIcon, GraphqlIcon, Auth0Icon,
} from "@/components/home/TechIcons";

const technologies = [
    // Frontend & UI
    { id: 1, name: "React", Icon: ReactIcon },
    { id: 2, name: "Next.js", Icon: NextjsIcon },
    { id: 3, name: "Vue.js", Icon: VueIcon },
    { id: 4, name: "Angular", Icon: AngularIcon },
    { id: 5, name: "JavaScript", Icon: JavaScriptIcon },
    { id: 6, name: "TypeScript", Icon: TypeScriptIcon },
    { id: 7, name: "HTML", Icon: HTMLIcon },
    { id: 8, name: "CSS", Icon: CSSIcon },
    { id: 9, name: "Sass", Icon: SassIcon },
    { id: 10, name: "Tailwind CSS", Icon: TailwindIcon },
    { id: 11, name: "Redux", Icon: ReduxIcon },
    { id: 12, name: "jQuery", Icon: jQueryIcon },
    { id: 13, name: "Vite", Icon: ViteIcon },
    { id: 14, name: "Material UI", Icon: MaterialIcon },
    { id: 15, name: "Ant Design", Icon: AntDesignIcon },

    // Backend & DevOps
    { id: 16, name: "Node.js", Icon: NodejsIcon },
    { id: 17, name: "Python", Icon: PythonIcon },
    { id: 18, name: "Flask", Icon: FlaskIcon },
    { id: 19, name: "django", Icon: djangoIcon },
    { id: 20, name: "TensorFlow", Icon: TensorFlowIcon },
    { id: 21, name: "Rails", Icon: RailsIcon },
    { id: 22, name: "PHP", Icon: PhpIcon },
    { id: 23, name: "Laravel", Icon: LaravelIcon },
    { id: 24, name: "CodeIgniter", Icon: CodeIgniterIcon },
    { id: 25, name: ".NET", Icon: DotNetIcon },
    { id: 26, name: "Java", Icon: JavaIcon },
    { id: 27, name: "C#", Icon: CSharpIcon },
    { id: 28, name: "Kotlin", Icon: KotlinIcon },
    { id: 29, name: "AWS", Icon: AWSIcon },
    { id: 30, name: "Google Cloud", Icon: GoogleCloudIcon },
    { id: 31, name: "Azure", Icon: AzureIcon },
    { id: 32, name: "Azure DevOps", Icon: AzureDevopsIcon },
    { id: 33, name: "Docker", Icon: DockerIcon },
    { id: 34, name: "Jenkins", Icon: JenkinsIcon },
    { id: 35, name: "GIT", Icon: GitIcon },
    { id: 36, name: "Apache", Icon: ApacheIcon },
    { id: 37, name: "cPanel", Icon: CpanelIcon },

    // Databases, Mobile & CMS
    { id: 38, name: "Go", Icon: GoLangIcon },
    { id: 39, name: "MySQL", Icon: MySqlIcon },
    { id: 40, name: "PostgreSQL", Icon: PostgreSqlIcon },
    { id: 41, name: "MongoDB", Icon: MongoDbIcon },
    { id: 42, name: "Oracle", Icon: OracleIcon },
    { id: 43, name: "Firebase", Icon: FirebaseIcon },
    { id: 44, name: "Nginx", Icon: NginxIcon },
    { id: 45, name: "Flutter", Icon: FlutterIcon },
    { id: 46, name: "Swift", Icon: SwiftIcon },
    { id: 47, name: "WordPress", Icon: WordpressIcon },
    { id: 48, name: "WooCommerce", Icon: WooCommerceIcon },
    { id: 49, name: "Shopify", Icon: ShopifyIcon },
    { id: 50, name: "OpenCart", Icon: OpenCartIcon },
    { id: 51, name: "Drupal", Icon: DrupalIcon },
    { id: 52, name: "Joomla", Icon: JoomlaIcon },
    { id: 53, name: "Magneto", Icon: MagnetoIcon },

    // Testing, Automation & Productivity
    { id: 54, name: "Fast API", Icon: FastAPIIcon },
    { id: 55, name: "Selenium", Icon: SeleniumIcon },
    { id: 56, name: "Cypress", Icon: CypressIcon },
    { id: 57, name: "UI Path", Icon: UIPathIcon },
    { id: 58, name: "Power BI", Icon: PowerBIIcon },
    { id: 59, name: "Qlik", Icon: QlikIcon },
    { id: 60, name: "Power Automate", Icon: PowerAutomateIcon },
    { id: 61, name: "OpenCV", Icon: OpenCVIcon },
    { id: 62, name: "Figma", Icon: FigmaIcon },
    { id: 63, name: "Adobe", Icon: AdobeIcon },
    { id: 64, name: "Atlassian", Icon: AtlassianIcon },
    { id: 65, name: "Notion", Icon: NotionIcon },
    { id: 66, name: "Zoho", Icon: ZohoIcon },
    { id: 67, name: "Microsoft Office", Icon: MSOfficeIcon },
    { id: 68, name: "Zimbra", Icon: ZimbraIcon },

    // Modern Web, Cloud & Enterprise Tech
    { id: 69, name: "Bootstrap", Icon: BootstrapIcon },
    { id: 70, name: "Spring Boot", Icon: SpringbootIcon },
    { id: 71, name: "Kubernetes", Icon: KubernetesIcon },
    { id: 72, name: "Prometheus", Icon: PrometheusIcon },
    { id: 73, name: "Digital Ocean", Icon: DigitalOceanIcon },
    { id: 74, name: "Cloudflare", Icon: CloudflareIcon },
    { id: 75, name: "Redis", Icon: RedisIcon },
    { id: 76, name: "Microsoft SQL Server", Icon: SQLServerIcon },
    { id: 77, name: "Android", Icon: AndroidIcon },
    { id: 78, name: "Apple", Icon: AppleIcon },
    { id: 79, name: "Dart", Icon: DartIcon },
    { id: 80, name: "GitHub", Icon: GitHubIcon },
    { id: 81, name: "Jest", Icon: JestIcon },
    { id: 82, name: "Salesforce", Icon: SalesforceIcon },
    { id: 83, name: "SAP", Icon: SAPIcon },
    { id: 84, name: "Odoo", Icon: OdooIcon },
    { id: 85, name: "GraphQL", Icon: GraphqlIcon },
    { id: 86, name: "Auth0", Icon: Auth0Icon },
];

const columns = [
    technologies.slice(0, 22),
    technologies.slice(22, 44),
    technologies.slice(44, 66),
    technologies.slice(66, 86),
];

function LogoCard({ tech }) {
    const { Icon } = tech;
    return (
        <div className="group h-14 relative flex items-center gap-3 rounded-xl border border-slate-200 bg-white shadow-sm px-4 py-3.5 hover:border-primary/50 hover:shadow-md transition-all duration-200 cursor-default">
            <Icon size={32} className="flex-shrink-0" />
            <span className="text-sm font-semibold text-foreground whitespace-nowrap pr-3">
                {tech.name}
            </span>
        </div>
    );
}

function ScrollColumn({ items, direction = "up", speed = "30s", delay = "0s" }) {
    const doubled = [...items, ...items];
    return (
        <div className="flex-1 overflow-hidden">
            <div
                className="flex flex-col gap-3"
                style={{
                    animation: `tech-scroll-${direction} ${speed} linear infinite`,
                    animationDelay: delay,
                }}
            >
                {doubled.map((tech, i) => (
                    <LogoCard key={`${tech.id}-${i}`} tech={tech} />
                ))}
            </div>
        </div>
    );
}

const defaults = {
    topText: "Our Tech Arsenal",
    titleText: "Transform Through",
    coloredText: "Technology",
    description:
        "We stay ahead of the curve so your products stay ahead of the competition. From modern frontend frameworks to cloud-native infrastructure, we choose the right stack for every challenge.",
};

// Only mount the logo marquee for the current layout — rendering both the desktop
// columns and the mobile rows put ~350 cards/imgs in the DOM. null = not known yet (SSR).
function useIsDesktop() {
    const [isDesktop, setIsDesktop] = useState(null);
    useEffect(() => {
        const mq = window.matchMedia("(min-width: 1024px)");
        const update = () => setIsDesktop(mq.matches);
        update();
        mq.addEventListener("change", update);
        return () => mq.removeEventListener("change", update);
    }, []);
    return isDesktop;
}

export default function HomeTechnologiesSection({ topText, titleText, coloredText, description }) {
    const isDesktop = useIsDesktop();
    return (
        <section className="py-12 md:py-20 bg-white overflow-hidden">
            <style>{`
        @keyframes tech-scroll-up {
          from { transform: translateY(0); }
          to   { transform: translateY(-50%); }
        }
        @keyframes tech-scroll-down {
          from { transform: translateY(-50%); }
          to   { transform: translateY(0); }
        }
      `}</style>

            <div className="max-w-[1400px] mx-auto px-6 relative">
                <SectionShapes variant="light" />

                {/* Mobile / tablet: stacked header */}
                <div className="lg:hidden text-center mb-10">
                    <GlobalTitle
                        topText={topText ?? defaults.topText}
                        titleText={titleText ?? defaults.titleText}
                        coloredText={coloredText ?? defaults.coloredText}
                        classes="text-center"
                        topTextClass="justify-center"
                    />
                    <p className="text-muted-foreground leading-relaxed max-w-lg mx-auto -mt-4">
                        {description ?? defaults.description}
                    </p>
                </div>

                {/* Desktop: 3-panel layout */}
                <div className="hidden lg:grid grid-cols-[1fr_380px_1fr] gap-8 items-center">

                    {/* Left: 2 scrolling columns */}
                    <div
                        className="flex gap-3 h-[520px]"
                        style={{
                            maskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)",
                            WebkitMaskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)",
                        }}
                    >
                        {isDesktop && (
                            <>
                                <ScrollColumn items={columns[0]} direction="up" speed="28s" delay="0s" />
                                <ScrollColumn items={columns[1]} direction="down" speed="32s" delay="-8s" />
                            </>
                        )}
                    </div>

                    {/* Center: heading + highlight card */}
                    <div className="flex flex-col items-center text-center relative z-10">
                        <GlobalTitle
                            topText={topText ?? defaults.topText}
                            titleText={titleText ?? defaults.titleText}
                            coloredText={coloredText ?? defaults.coloredText}
                            classes="text-center"
                            topTextClass="justify-center"
                        />

                        <div className="w-full rounded-3xl border border-slate-200 bg-white shadow-xl overflow-hidden">
                            <div
                                className="h-1.5"
                                style={{ background: "var(--grad-red)" }}
                            />
                            <div className="p-6">
                                <div className="flex items-center gap-3 mb-4">
                                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                                        <Sparkles size={16} className="text-primary" />
                                    </div>
                                    <div className="text-left">
                                        <p className="font-bold text-base text-foreground leading-tight">End-to-end technology delivery</p>
                                    </div>
                                </div>

                                <p className="text-muted-foreground text-left mb-5">
                                    We use a modern, industry-standard technology stack to deliver scalable, secure, and high-performance software solutions across web, mobile, cloud, and enterprise applications.
                                </p>

                                <Link href="/technology" className="w-full flex items-center justify-center gap-2 rounded-full bg-primary text-white py-2.5 px-5 text-sm font-semibold hover:bg-primary/90 transition-colors cursor-pointer">
                                    Explore Our Stack <ArrowUpRight size={16} />
                                </Link>
                            </div>
                        </div>
                    </div>

                    {/* Right: 2 scrolling columns */}
                    <div
                        className="flex gap-3 h-[520px]"
                        style={{
                            maskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)",
                            WebkitMaskImage: "linear-gradient(to bottom, transparent, black 15%, black 85%, transparent)",
                        }}
                    >
                        {isDesktop && (
                            <>
                                <ScrollColumn items={columns[2]} direction="down" speed="35s" delay="-12s" />
                                <ScrollColumn items={columns[3]} direction="up" speed="28s" delay="-4s" />
                            </>
                        )}
                    </div>

                </div>

                {/* Mobile / tablet: 4-row marquee, alternating scroll direction */}
                <div className="lg:hidden mt-8 flex flex-col gap-3 min-h-[212px]">
                    {isDesktop === false && columns.map((col, i) => (
                        <div
                            key={i}
                            className="overflow-hidden"
                            style={{
                                maskImage: "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
                                WebkitMaskImage: "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
                            }}
                        >
                            <div
                                className="flex gap-3"
                                style={{
                                    animation: `marquee-scroll ${55 + i * 8}s linear infinite`,
                                    animationDirection: i % 2 === 0 ? "normal" : "reverse",
                                    width: "max-content",
                                }}
                            >
                                {[...col, ...col].map((tech, idx) => (
                                    <div
                                        key={idx}
                                        className="flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-3.5 py-2.5 shadow-sm whitespace-nowrap flex-shrink-0"
                                    >
                                        <tech.Icon size={22} className="flex-shrink-0" />
                                        <span className="text-sm font-semibold text-foreground">{tech.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Mobile / tablet: bottom CTA */}
                <div className="lg:hidden mt-8 flex justify-center">
                    <Link
                        href="/technology"
                        className="w-full sm:w-auto flex items-center justify-center gap-2 rounded-full bg-primary text-white py-3 px-6 text-sm font-semibold hover:bg-primary/90 transition-colors cursor-pointer"
                    >
                        Explore Our Stack <ArrowUpRight size={16} />
                    </Link>
                </div>

            </div>
        </section>
    );
}